import { forwardRef } from 'react';
import MuiPaper, { type PaperProps as MuiPaperProps } from '@mui/material/Paper';

export type PaperProps = MuiPaperProps;

export const Paper = forwardRef<HTMLDivElement, PaperProps>(
  ({ elevation = 0, ...rest }, ref) => <MuiPaper ref={ref} elevation={elevation} {...rest} />
);

Paper.displayName = 'Paper';
